<template>
  <div id="app">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "Wrapper",
  components: {}
};
</script>

<style>
:root {
  --WHITE: #fff;
  --BLACK: #252525;
  --RED: #ffd7d7;
  --GREY: #e9e9e9;
  --BLUE: #1a4abe;
  --LIGHTBLUE: #1c5cf7;
  --FONT-SIZE: 18px;
  --LINE-HEIGHT: 25px;
  --TRANSITION: all 0.2s ease;
}

@font-face {
  font-family: "Urby-Regular";
  src: url("/static/Urby-TypeMates/Webfonts/Urby-Regular.eot");
  src: url("/static/Urby-TypeMates/Webfonts/Urby-Regular.eot?#iefix")
      format("embedded-opentype"),
    url("/static/Urby-TypeMates/Webfonts/Urby-Regular.woff2") format("woff2"),
    url("/static/Urby-TypeMates/Webfonts/Urby-Regular.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

body {
  margin: 0;
  padding: 0;
  background-color: var(--WHITE);
  overflow-x: hidden;
}
/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}

@import url("https://rsms.me/inter/inter.css");

html {
  font-family: inter;
}
@supports (font-variation-settings: normal) {
  html {
    font-family: "Inter var", sans-serif;
  }
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--BLACK);
  background-color: var(--WHITE);
  text-align: left;
}

section {
  /* padding-bottom: var(--SPACE-BOTTOM-x5); */
}

.content {
  margin-left: var(--EXTRA-SPACE-LEFT);
}

.txt p {
  font-size: var(--FONT-SIZE);
  line-height: var(--LINE-HEIGHT);
  font-style: normal;
  font-weight: normal;
  padding-bottom: var(--LINE-HEIGHT);
  letter-spacing: -0.3px;
}

.txt strong {
  font-weight: bold;
  line-height: var(--LINE-HEIGHT);
}

.txt i {
  font-style: italic;
  line-height: var(--LINE-HEIGHT);
}

.txt a {
  color: inherit;
  line-height: var(--LINE-HEIGHT);
  text-decoration-thickness: 1px;
  text-decoration-width: 1px;
  transition: var(--TRANSITION);
  transition-property: text-decoration-color, text-decoration-thickness,
    text-decoration-width;
}

.txt a:hover {
  text-decoration-thickness: 3px;
}

.txt h2 {
  text-indent: -4px;
  font-family: Urby-Regular, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 45px;
  line-height: 50px;
  margin-bottom: var(--SPACE-BOTTOM-x2);
}

@media only screen and (max-width: 576px) {
  .txt h2 {
    text-indent: -2px;
    font-size: 35px;
    line-height: 50px;
    margin-bottom: var(--SPACE-BOTTOM-x2);
  }
  .txt h2.line-height-fix {
    line-height: 35px;
  }

  .txt h2.line-height-fix span {
    display: block;
  }
}

.txt ol {
  list-style: none;
  counter-reset: item;
  padding-bottom: var(--LINE-HEIGHT);
}

.txt li {
  margin-bottom: 10px;
  position: relative;
  font-size: var(--FONT-SIZE);
  line-height: var(--LINE-HEIGHT);
  letter-spacing: -0.5px;
  font-size: 20px;
}

@media only screen and (max-width: 576px) {
  .txt li {
    font-size: 18px;
  }
} /*
@media only screen and (min-width: 576px) and (max-width: 767px) {}
@media only screen and (min-width: 768px) and (max-width: 992px) {}
@media only screen and (min-width: 992px) {}
*/

.txt ol li {
  margin-left: 30px;
  counter-increment: item;
}

.txt ol li span {
  word-wrap: none;
  display: inline-block;
}
.txt ol li:before {
  left: -30px;
  width: 30px;
  letter-spacing: -0.3px;
  content: counter(item);
  text-align: left;
  position: absolute;
  display: inline-block;
  font-weight: bold;
}

.txt .smallprint {
  font-size: 16px;
}
@media only screen and (max-width: 576px) {
  .txt .smallprint {
    font-size: 16px;
  }
} /*
@media only screen and (min-width: 576px) and (max-width: 767px) {}
@media only screen and (min-width: 768px) and (max-width: 992px) {}
@media only screen and (min-width: 992px) {}
*/
</style>



// WEBPACK FOOTER //
// src/components/Wrapper.vue